import React from "react";
import styled from "styled-components";
import logoPNG from "./../assets/img/logo.png";
import { Link } from "react-router-dom";

const FloatingContainer = styled.div`
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);

    ${({ show }) => (show ? "" : "display:none;")};

    img {
        max-width: 250px;
    }

    @media screen and (max-width: 830px) {
        display: none;
    }
`;

const FloatingLogo = ({ shouldShow }) => (
    <FloatingContainer show={shouldShow}>
        <Link to="/">
            <picture>
                <img src={logoPNG} alt="Logo magazynu Zdrowe Dziecko" />
            </picture>
        </Link>
    </FloatingContainer>
);
export default FloatingLogo;
